import { render } from "./JobsStatistic.vue?vue&type=template&id=c1f4edc0&ts=true"
import script from "./JobsStatistic.vue?vue&type=script&lang=ts"
export * from "./JobsStatistic.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__